import { withInstall } from '@tw-element/utils'

import Divider from './src/divider.vue'

export const TwDivider = withInstall(Divider)
export default TwDivider

export * from './src/divider'
